// extracted by mini-css-extract-plugin
export default {"noResults":"Style_noResults__kcmD4"};